<template>
  <VDialogV3
    id="transport-zone-card"
    position="right"
    width="600px"
    height="100vh"
    :entity="localTransportZone"
    :loading="localTransportZone == null"
    :title="localTransportZone?.toString()"
    :context-menu="editMode ? TransportZonesService.contextMenu : null"
    :submit-disabled="isSaveDisabled"
    @submit-button:clicked="onSubmit"
  >
   <section>
     <VInput
       v-model="localTransportZone.name"
       label="Наименование зоны"
       layout="vertical"
       required
       placeholder="Введите зону"
     />
   </section>
  </VDialogV3>
</template>

<script lang="ts">

import TransportZone from '@/domains/TransportZones/TransportZone';
import TransportZonesService from '@/domains/TransportZones/TransportZonesService';

import ValidationFormMixin from '@/mixins/validation-form-mixin';
import ValidationMixin from "@/mixins/validation-mixin";

export default defineComponent({
  name: 'TransportZoneCard',

  mixins: [ValidationFormMixin, ValidationMixin],

  props: {
    /** Готовый объект зоны — передаётся из реестра / меню */
    transportZone: {
      type: TransportZone,
      default: null,
    },
    /** ID зоны — передаётся из роутера, карточка сама загружает объект */
    id: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      TransportZonesService,
      localTransportZone: null as TransportZone | null,
    };
  },

  computed: {
    editMode(): boolean {
      return this.localTransportZone?.id != null;
    },

    isSaveDisabled(): boolean {
      return !this.isValid || this.isValidationLoading;
    },
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id) {
        this.localTransportZone = await TransportZonesService.get(this.id);
      } else if (this.transportZone instanceof TransportZone) {
        this.localTransportZone = this.$core.utils.cloneDeep(this.transportZone);
      } else {
        this.localTransportZone = TransportZone.fromNew();
      }
    },

    async onSubmit(): Promise<void> {

      const success = this.editMode
        ? await TransportZonesService.update(this.localTransportZone!)
        : await TransportZonesService.add(this.localTransportZone!);


      if (success) {
        this.$core.dialogs.TransportZoneCard.resolve();
      }
    },
  },
});
</script>
